module.exports = __webpack_public_path__ + "static/media/topup_request.14702ba9.svg";